import axios from 'axios';
import consts from '../constant';

const API_BASE = consts.BackendUrl;
const getAuthHeaders = () => ({
  headers: {
    Authorization: `Bearer ${window.localStorage.getItem("Jetix")}`,
  },
});

// Create a new pair
export const createPair = async (data) => {
  try {
    const response = await axios.post(`${API_BASE}/add-pairs`, data, getAuthHeaders());
    return response.data;
  } catch (error) {
    return error.response?.data || error;
  }
};

// Update an existing pair
export const updatePair = async (pairId, data) => {
  try {
    const response = await axios.post(`${API_BASE}/update-pairs`, { pairId, ...data }, getAuthHeaders());
    return response.data;
  } catch (error) {
    return error.response?.data || error;
  }
};

// Delete a pair
export const deletePair = async (pairId) => {
  try {
    const response = await axios.post(`${API_BASE}/delete-pair`, { pairId }, getAuthHeaders());
    return response.data;
  } catch (error) {
    return error.response?.data || error;
  }
};

// Get pair by ID
export const getPairById = async (pairId) => {
  try {
    const response = await axios.post(`${API_BASE}/get-pair`, { pairId }, getAuthHeaders());
    return response.data;
  } catch (error) {
    return error.response?.data || error;
  }
};

// Upload image
export const uploadImage = async (file) => {
  try {
    const formData = new FormData();
    formData.append('image', file);
    const response = await axios.post(`${API_BASE}/uploadImage`, formData, {
      ...getAuthHeaders(),
      'Content-Type': 'multipart/form-data',
    });
    return response.data;
  } catch (error) {
    return error.response?.data || error;
  }
};